import { createContext, useContext, useEffect, useState } from "react";
import thisApi from "../API/dynamicPagesApis/dynamicPagesApi";
import Swal from "sweetalert2";

const DynamicPagesContext = createContext({
  types: [],
  addTypes: () => {},
  addPageData: () => {},
  pagesLoader: false,
  setPagesLoader: () => {},
  updatePagesSingle: () => {},
  updateTypes: () => {},
  getTypesData: () => {},
});

export const DynamicPagesContextProvider = ({ children }) => {
  const [types, setTypes] = useState([]);
  const [pagesData, setPagesData] = useState([]);
  const [pagesLoader, setPagesLoader] = useState(false);

  const fetchTypes = () => {
    thisApi.fetchTypes().then((res) => {
      console.log(res, "fetch types");
      setTypes(res.data.data);
    });
  };

  const getTypesData = (reqeust) => {
    return types.length > 0 && types?.filter((obj) => obj.id === reqeust.id)[0];
  };

  const addTypes = (typesData) => {
    thisApi
      .storeTypes(typesData)
      .then((res) => {
        console.log(res, "add types");
        if (res.status === 201) {
          Swal.fire({
            title: "Success!",
            text: "Added Succeffully !",
            icon: "success",
            confirmButtonText: "Ok",
          });
          setTypes((prevTypes) => [...prevTypes, res.data.data]);
        }
      })
      .catch((err) => {
        console.log(err, "error");

        Swal.fire({
          title: "error",
          text: Object.entried(err.response.data.errors).map(
            (obj) => obj.title
          ),
        });
      });
  };

  const updateTypes = (id, data) => {
    thisApi
      .updateTypes(id, data)
      .then((res) => {
        console.log(res, "update types");
      })
      .catch((err) => {
        const { errors } = err.response?.data;
        console.log(errors, "update types");
        if (errors) {
          Swal.fire({
            title: "Error",
            text: Object.values(errors).flat().join(", "),
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      });
  };

  const fetchPages = () => {
    setPagesLoader(true);
    thisApi.fetchPages().then((res) => {
      console.log(res, "pages");
      setPagesData(res.data.data);
      setPagesLoader(false);
    });
  };

  const addPageData = (DATA) => {
    thisApi
      .storePages(DATA)
      .then((res) => {
        console.log(res);
        fetchPages();
        if (!res.data.status) {
          Swal.fire({
            title: "Error",
            text: res.data.message,
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
        if (res.status === 200) {
          Swal.fire({
            title: "Success!",
            text: "Pages Added Succeffully !",
            icon: "success",
            confirmButtonText: "Ok",
          });
        }
      })
      .catch((err) => {
        const { errors } = err.response?.data;
        console.log(errors, "update types");
        if (errors) {
          Swal.fire({
            title: "Error",
            text: Object.values(errors).flat().join(", "),
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      });
  };

  const updatePagesSingle = (id, data) => {
    thisApi
      .updatePages(id, data)
      .then((res) => {
        console.log(res, "updatePagesSingle ");
        if (res.status === 200) {
          Swal.fire({
            title: "Success!",
            text: "Pages Added Succeffully !",
            icon: "success",
            confirmButtonText: "Ok",
          });
        }
        fetchPages();
      })
      .catch((err) => {
        const { errors } = err.response?.data;
        console.log(errors, "update types");
        if (errors) {
          Swal.fire({
            title: "Error",
            text: Object.values(errors).flat().join(", "),
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
        alert("Something went wrong");
      });
  };

  useEffect(() => {
    fetchTypes();
    fetchPages();
  }, []);

  return (
    <DynamicPagesContext.Provider
      value={{
        addTypes,
        types,
        addPageData,
        pagesData,
        pagesLoader,
        updatePagesSingle,
        updateTypes,
        getTypesData,
      }}
    >
      {children}
    </DynamicPagesContext.Provider>
  );
};
export const useDynamicPagesContext = () => {
  return useContext(DynamicPagesContext);
};

export default DynamicPagesContext;
